import {Cookies} from 'react-cookie';

export function getCookie(cookieName){
	const cookies = new Cookies();
	return cookies.get(cookieName);
}



// WEBPACK FOOTER //
// ./src/js/utils/cookies.js